import { fetchRecurringCharges } from '../../actions'

export const cancelRecurringCharge = (recurring_charge_id) => {
  return (dispatch, getState) => {
    const state = getState()
    const { name } = state.organization
    const { id } = state.resident

    dispatch({ type: 'BEGIN_CANCEL_RECURRING_CHARGE' })
    $.ajax({
      url: `/organizations/${name}/residents/${id}/recurring_charges/${recurring_charge_id}/cancel.json`,
      method: 'PATCH',
      success: (response) => {
          dispatch(fetchRecurringCharges())
          dispatch({ type: 'SUCCESS_CANCEL_RECURRING_CHARGE', payload: response })
      },
      error: (xhr) => {
          dispatch({ type: 'FAILED_CANCEL_RECURRING_CHARGE', payload: [] })
      }
    })
  }
}